import { Box } from '@mui/material';
import { MarkdownEditor } from '@/components/shared/markdown-renderer/remirror';

interface MarkdownRendererProps {
  markdown: string;
  placeholder?: string;
  translatable?: boolean;
}

export const MarkdownRenderer = ({
  markdown,
  placeholder = '',
  translatable = true,
}: MarkdownRendererProps) => {
  return (
    <Box sx={{ '&& > *:last-child': { mb: '0' } }}>
      <MarkdownEditor
        editable={false}
        markdown={markdown}
        placeholder={placeholder}
        translatable={translatable}
      />
    </Box>
  );
};
